/* ==================================================
   MATCH DETAILS 2026 — MEN
   ================================================== */

import type { MatchDetails } from "./types";

export const matchDetailsMen: MatchDetails[] = [
  // ==================================================
  // BARBARIANS
  // ==================================================

  {
    matchKey: "south-africa-vs-barbarians",
  },

  // ==================================================
  // NATIONS CHAMPIONSHIP 2026 — ROUND 1
  // ==================================================

  {
    matchKey: "south-africa-vs-england",
    performances: [
      { category: "Captain", player: "Siya Kolisi", value: "South Africa" },
      { category: "Captain", player: "Jamie George", value: "England" },
      { category: "Venue", player: "Ellis Park", value: "Johannesburg" },
    ],
  },

  {
    matchKey: "new-zealand-vs-france",
    performances: [
      { category: "Captain", player: "Ardie Savea", value: "New Zealand" },
      { category: "Captain", player: "Maxime Lucu", value: "France" },
      { category: "Venue", player: "One New Zealand Stadium", value: "Christchurch" },
    ],
  },

  {
    matchKey: "australia-vs-ireland",
    performances: [
      { category: "Captain", player: "Harry Wilson", value: "Australia" },
      { category: "Captain", player: "Dan Sheehan", value: "Ireland" },
      { category: "Selection note", player: "Jock Campbell", value: "Returns at fullback" },
    ],
  },

  {
    matchKey: "japan-vs-italy",
    performances: [
      { category: "Captain", player: "Warner Dearns", value: "Japan" },
      { category: "Captain", player: "Michele Lamaro", value: "Italy" },
      { category: "Venue", player: "Chichibunomiya Rugby Stadium", value: "Tokyo" },
    ],
  },

  {
    matchKey: "fiji-vs-wales",
    performances: [
      { category: "Captain", player: "Tevita Ikanivere", value: "Fiji" },
      { category: "Captain", player: "Dewi Lake", value: "Wales" },
      { category: "Venue", player: "Cardiff City Stadium", value: "Cardiff" },
    ],
  },

  {
    matchKey: "argentina-vs-scotland",
    performances: [
      { category: "Captain", player: "Julian Montoya", value: "Argentina" },
      { category: "Captain", player: "Sione Tuipulotu", value: "Scotland" },
      { category: "Venue", player: "Estadio Mario Alberto Kempes", value: "Cordoba" },
    ],
  },

  // ==================================================
  // NATIONS CHAMPIONSHIP 2026 — ROUND 2
  // ==================================================

  {
    matchKey: "new-zealand-vs-italy",
    performances: [
      { category: "Captain", player: "Ardie Savea", value: "New Zealand" },
      { category: "Captain", player: "Michele Lamaro", value: "Italy" },
      { category: "Venue", player: "Sky Stadium", value: "Wellington" },
    ],
  },

  {
    matchKey: "australia-vs-france",
    performances: [
      { category: "Captain", player: "Harry Wilson", value: "Australia" },
      { category: "Captain", player: "Maxime Lucu", value: "France" },
      { category: "Venue", player: "Suncorp Stadium", value: "Brisbane" },
    ],
  },

  {
    matchKey: "japan-vs-ireland",
    performances: [
      { category: "Captain", player: "Warner Dearns", value: "Japan" },
      { category: "Captain", player: "Tadhg Beirne", value: "Ireland" },
      { category: "Venue", player: "McDonald Jones Stadium", value: "Newcastle" },
    ],
  },

  {
    matchKey: "fiji-vs-england",
    performances: [
      { category: "Captain", player: "Tevita Ikanivere", value: "Fiji" },
      { category: "Captain", player: "Jamie George", value: "England" },
      { category: "Venue", player: "Hill Dickinson Stadium", value: "Liverpool" },
    ],
  },

  {
    matchKey: "south-africa-vs-scotland",
    performances: [
      { category: "Captain", player: "Pieter-Steph du Toit", value: "South Africa" },
      { category: "Captain", player: "Sione Tuipulotu", value: "Scotland" },
      { category: "Venue", player: "Loftus Versfeld", value: "Pretoria" },
    ],
  },

  {
    matchKey: "argentina-vs-wales",
    performances: [
      { category: "Captain", player: "Julian Montoya", value: "Argentina" },
      { category: "Captain", player: "Dewi Lake", value: "Wales" },
      { category: "Venue", player: "Estadio San Juan del Bicentenario", value: "San Juan" },
    ],
  },

  // ==================================================
  // WORLD RUGBY NATIONS CUP 2026 — ROUND 2
  // ==================================================

  {
    matchKey: "uruguay-vs-romania",
    performances: [
      { category: "Captain", player: "Felipe Aliaga", value: "Uruguay" },
      { category: "Captain", player: "Cristi Boboc", value: "Romania" },
      { category: "Venue", player: "Estadio Charrúa", value: "Montevideo" },
    ],
  },

  {
    matchKey: "chile-vs-hong-kong-china",
    performances: [
      { category: "Captain", player: "Martín Sigren", value: "Chile" },
      { category: "Captain", player: "Josh Hrstich", value: "Hong Kong China" },
      { category: "Venue", player: "Estadio Sausalito", value: "Viña del Mar" },
    ],
  },

  {
    matchKey: "canada-vs-portugal",
    performances: [
      { category: "Captain", player: "Andrew Quattrin", value: "Canada" },
      { category: "Captain", player: "José Madeira", value: "Portugal" },
      { category: "Venue", player: "Clarke Stadium", value: "Edmonton" },
    ],
  },

  {
    matchKey: "tonga-vs-spain",
    performances: [
      { category: "Captain", player: "Sonatane Takulua", value: "Tonga" },
      { category: "Captain", player: "TBD", value: "Spain" },
      { category: "Venue", player: "Clarke Stadium", value: "Edmonton" },
    ],
  },

  {
    matchKey: "samoa-vs-georgia",
    performances: [
      { category: "Captain", player: "TBD", value: "Samoa" },
      { category: "Captain", player: "Davit Niniashvili", value: "Georgia" },
      { category: "Venue", player: "Estadio Sausalito", value: "Viña del Mar" },
    ],
  },

  {
    matchKey: "usa-vs-zimbabwe",
    performances: [
      { category: "Captain", player: "Jason Damm", value: "USA" },
      { category: "Captain", player: "Tino Mavesere", value: "Zimbabwe" },
      { category: "Venue", player: "American Legion Memorial Stadium", value: "Charlotte" },
    ],
  },

  // ==================================================
  // WORLD RUGBY NATIONS CUP 2026 — ROUND 3
  // ==================================================

  {
    matchKey: "samoa-vs-romania",
    performances: [
      { category: "Captain", player: "TBD", value: "Samoa" },
      { category: "Captain", player: "Cristi Boboc", value: "Romania" },
      { category: "Venue", player: "Estadio Charrúa", value: "Montevideo" },
    ],
  },

  {
    matchKey: "uruguay-vs-hong-kong-china",
    performances: [
      { category: "Captain", player: "Felipe Aliaga", value: "Uruguay" },
      { category: "Captain", player: "Joshua Hrstich", value: "Hong Kong China" },
      { category: "Venue", player: "Estadio Charrúa", value: "Montevideo" },
    ],
  },

  {
    matchKey: "tonga-vs-portugal",
    performances: [
      { category: "Captain", player: "TBD", value: "Tonga" },
      { category: "Captain", player: "TBD", value: "Portugal" },
      { category: "Venue", player: "Princess Auto Stadium", value: "Winnipeg" },
    ],
  },

  {
    matchKey: "chile-vs-georgia",
    performances: [
      { category: "Captain", player: "Martín Sigren", value: "Chile" },
      { category: "Captain", player: "Davit Niniashvili", value: "Georgia" },
      { category: "Venue", player: "Estadio La Portada", value: "La Serena" },
    ],
  },

  {
    matchKey: "usa-vs-spain",
    performances: [
      { category: "Captain", player: "Jason Damm", value: "USA" },
      { category: "Captain", player: "TBD", value: "Spain" },
      { category: "Venue", player: "WakeMed Soccer Park", value: "Cary" },
    ],
  },

  {
    matchKey: "canada-vs-zimbabwe",
    performances: [
      { category: "Captain", player: "Andrew Quattrin", value: "Canada" },
      { category: "Captain", player: "Tinotenda Mavesere", value: "Zimbabwe" },
      { category: "Venue", player: "Princess Auto Stadium", value: "Winnipeg" },
    ],
  },

  // ==================================================
  // NATIONS CHAMPIONSHIP 2026 — ROUND 3
  // ==================================================

  {
    matchKey: "new-zealand-vs-ireland",
    performances: [
      { category: "Captain", player: "Ardie Savea", value: "New Zealand" },
      { category: "Captain", player: "Dan Sheehan", value: "Ireland" },
      { category: "Venue", player: "Eden Park", value: "Auckland" },
    ],
  },

  {
    matchKey: "japan-vs-france",
    performances: [
      { category: "Captain", player: "Warner Dearns", value: "Japan" },
      { category: "Captain", player: "Maxime Lucu", value: "France" },
      { category: "Venue", player: "MUFG Stadium", value: "Tokyo" },
    ],
  },

  {
    matchKey: "australia-vs-italy",
    performances: [
      { category: "Captain", player: "Harry Wilson", value: "Australia" },
      { category: "Captain", player: "Michele Lamaro", value: "Italy" },
      { category: "Venue", player: "HBF Park", value: "Perth" },
    ],
  },

  {
    matchKey: "fiji-vs-scotland",
    performances: [
      { category: "Captain", player: "Tevita Ikanivere", value: "Fiji" },
      { category: "Captain", player: "Stafford McDowall", value: "Scotland" },
      { category: "Venue", player: "Murrayfield", value: "Edinburgh" },
    ],
  },

  {
    matchKey: "south-africa-vs-wales",
    performances: [
      { category: "Captain", player: "Pieter-Steph du Toit", value: "South Africa" },
      { category: "Captain", player: "Dewi Lake", value: "Wales" },
      { category: "Venue", player: "Hollywoodbets Kings Park", value: "Durban" },
    ],
  },

  {
    matchKey: "argentina-vs-england",
    performances: [
      { category: "Captain", player: "Julian Montoya", value: "Argentina" },
      { category: "Captain", player: "Jamie George", value: "England" },
      { category: "Venue", player: "Estadio Único Madre de Ciudades", value: "Santiago del Estero" },
    ],
  },

  // ==================================================
  // THE RIVALRY TOUR 2026 — MIDWEEK MATCHES
  // ==================================================

  {
    matchKey: "stormers-vs-new-zealand",
    performances: [
      { category: "Coach", player: "John Dobson", value: "Stormers" },
      { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
      { category: "Captain", player: "Ruhan Nel", value: "Stormers" },
      { category: "Captain", player: "Patrick Tuipulotu", value: "New Zealand" },
      { category: "Venue", player: "Cape Town Stadium", value: "Cape Town" },
      { category: "Referee", player: "Karl Dickson", value: "RFU" },
      { category: "Assistant Referee 1", player: "Matthew Carley", value: "RFU" },
      { category: "Assistant Referee 2", player: "Hollie Davidson", value: "SRU" },
      { category: "TMO", player: "Andrew Jackson", value: "RFU" },
      { category: "FPRO", player: "Mike Adamson", value: "SRU" },
    ],
  },

  {
    matchKey: "sharks-vs-new-zealand",
    performances: [
      { category: "Coach", player: "JP Pietersen", value: "Sharks" },
      { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
      { category: "Captain", player: "Nick Hatton", value: "Sharks" },
      { category: "Captain", player: "Luke Jacobson", value: "New Zealand" },
      { category: "Venue", player: "Kings Park", value: "Durban" },
      { category: "Referee", player: "Matthew Carley", value: "RFU" },
      { category: "Assistant Referee 1", player: "Karl Dickson", value: "RFU" },
      { category: "Assistant Referee 2", player: "Hollie Davidson", value: "SRU" },
      { category: "TMO", player: "Mike Adamson", value: "SRU" },
    ],
  },

  {
    matchKey: "bulls-vs-new-zealand",
    highlightsUrl: "https://www.youtube.com/watch?v=WaQkx8-PBdI",
    matchStats: {
      home: {
        metresMade: 312,
        carries: 98,
        defendersBeaten: 14,
        cleanBreaks: 5,
        offloads: 8,
        tacklesMade: 142,
        tacklesMissed: 28,
        turnoversWon: 6,
        penaltiesConceded: 12,
      },
      away: {
        metresMade: 548,
        carries: 126,
        defendersBeaten: 31,
        cleanBreaks: 12,
        offloads: 15,
        tacklesMade: 118,
        tacklesMissed: 11,
        turnoversWon: 11,
        penaltiesConceded: 8,
      },
    },
    performances: [
      { category: "Coach", player: "Johan Ackermann", value: "Bulls" },
      { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
      { category: "Captain", player: "Marcell Coetzee", value: "Bulls" },
      { category: "Captain", player: "Codie Taylor", value: "New Zealand" },
      { category: "Venue", player: "Loftus Versfeld", value: "Pretoria" },
      { category: "Referee", player: "Nika Amashukeli", value: "GRU" },
      { category: "Assistant Referee 1", player: "Karl Dickson", value: "RFU" },
      { category: "Assistant Referee 2", player: "Matthew Carley", value: "RFU" },
      { category: "TMO", player: "Eric Gauzins", value: "FFR" },
    ],
  },

  {
    matchKey: "lions-vs-new-zealand",
    highlightsUrl: "https://www.youtube.com/watch?v=OKP0LgC5psY",
    matchStats: {
      home: {
        metresMade: 322,
        carries: 77,
        defendersBeaten: 18,
        cleanBreaks: 4,
        offloads: 6,
        tacklesMade: 147,
        tacklesMissed: 38,
        turnoversWon: 10,
        penaltiesConceded: 11,
      },
      away: {
        metresMade: 881,
        carries: 150,
        defendersBeaten: 32,
        cleanBreaks: 15,
        offloads: 12,
        tacklesMade: 85,
        tacklesMissed: 22,
        turnoversWon: 9,
        penaltiesConceded: 9,
      },
    },
  },

  // ==================================================
  // THE RIVALRY TOUR 2026 — TEST SERIES
  // ==================================================

  {
    matchKey: "south-africa-vs-new-zealand-test-1",
    highlightsUrl: "https://www.youtube.com/watch?v=zAbz3DiMcCw",
    matchStats: {
      home: {
        metresMade: 341,
        carries: 96,
        defendersBeaten: 21,
        cleanBreaks: 7,
        offloads: 2,
        tacklesMade: 89,
        tacklesMissed: 25,
        turnoversWon: 5,
        penaltiesConceded: 10,
      },
      away: {
        metresMade: 255,
        carries: 86,
        defendersBeaten: 25,
        cleanBreaks: 6,
        offloads: 4,
        tacklesMade: 129,
        tacklesMissed: 21,
        turnoversWon: 14,
        penaltiesConceded: 14,
      },
    },
    performances: [
      { category: "Coach", player: "Rassie Erasmus", value: "South Africa" },
      { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
      { category: "Captain", player: "Pieter-Steph du Toit", value: "South Africa" },
      { category: "Captain", player: "Ardie Savea", value: "New Zealand" },
      { category: "Venue", player: "Ellis Park", value: "Johannesburg" },
      { category: "Referee", player: "Matthew Carley", value: "RFU" },
      { category: "Assistant Referee 1", player: "Karl Dickson", value: "RFU" },
      { category: "Assistant Referee 2", player: "Nika Amashukeli", value: "GRU" },
      { category: "TMO", player: "Mike Adamson", value: "SRU" },
    ],
  },

  {
    matchKey: "south-africa-vs-new-zealand-test-2",
    highlightsUrl: "https://www.youtube.com/watch?v=pZB1nHh1Hps",
    matchStats: {
      home: {
        metresMade: 312,
        carries: 104,
        defendersBeaten: 19,
        cleanBreaks: 5,
        offloads: 7,
        tacklesMade: 188,
        tacklesMissed: 39,
        turnoversWon: 11,
        penaltiesConceded: 10,
      },
      away: {
        metresMade: 428,
        carries: 154,
        defendersBeaten: 28,
        cleanBreaks: 8,
        offloads: 12,
        tacklesMade: 122,
        tacklesMissed: 26,
        turnoversWon: 8,
        penaltiesConceded: 12,
      },
    },
  },

  {
  matchKey: "south-africa-vs-new-zealand-test-3",
highlightsUrl: "https://www.youtube.com/watch?v=mfz8yB0jOT0",
matchStats: {
  home: { // South Africa
    metresMade: 340,
    carries: 110,
    defendersBeaten: 18,
    cleanBreaks: 5,
    offloads: 6,
    tacklesMade: 150,
    tacklesMissed: 32,
    turnoversWon: 9,
    penaltiesConceded: 11,
  },
  away: { // New Zealand
    metresMade: 410,
    carries: 145,
    defendersBeaten: 26,
    cleanBreaks: 7,
    offloads: 10,
    tacklesMade: 106,
    tacklesMissed: 21,
    turnoversWon: 8,
    penaltiesConceded: 12,
  },
},
  performances: [
    { category: "Coach", player: "Rassie Erasmus", value: "South Africa" },
    { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
    { category: "Captain", player: "Siya Kolisi", value: "South Africa" },
    { category: "Captain", player: "Ardie Savea", value: "New Zealand" },
    { category: "Venue", player: "FNB Stadium", value: "Johannesburg" },
    { category: "Referee", player: "Nika Amashukeli", value: "GRU" },
    { category: "Assistant Referee 1", player: "Angus Gardner", value: "RA" },
    { category: "Assistant Referee 2", player: "Christophe Ridley", value: "RFU" },
    { category: "TMO", player: "Eric Gauzins", value: "FFR" },
  ],
},

{
  matchKey: "south-africa-vs-new-zealand-test-4",
  highlightsUrl: "https://www.youtube.com/watch?v=AdJgQNNSodM",
matchStats: {
  home: { // South Africa
    metresMade: 520,
    carries: 142,
    defendersBeaten: 28,
    cleanBreaks: 11,
    offloads: 9,
    tacklesMade: 161,
    tacklesMissed: 32,
    turnoversWon: 8,
    penaltiesConceded: 9,
  },
  away: { // New Zealand
    metresMade: 410,
    carries: 136,
    defendersBeaten: 22,
    cleanBreaks: 9,
    offloads: 11,
    tacklesMade: 184,
    tacklesMissed: 32,
    turnoversWon: 7,
    penaltiesConceded: 9,
  },
},
  performances: [
    { category: "Coach", player: "Rassie Erasmus", value: "South Africa" },
    { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
    { category: "Captain", player: "Siya Kolisi", value: "South Africa" },
    { category: "Captain", player: "Codie Taylor", value: "New Zealand" },
    { category: "Venue", player: "M&T Bank Stadium", value: "Baltimore" },
    { category: "Referee", player: "Karl Dickson", value: "RFU" },
    { category: "Assistant Referee 1", player: "Matthew Carley", value: "RFU" },
    { category: "Assistant Referee 2", player: "Christophe Ridley", value: "RFU" },
    { category: "TMO", player: "Andrew Jackson", value: "RFU" },
    { category: "FPRO", player: "Matteo Liperini", value: "FIR" },
  ],
},

  // ==================================================
  // INTERNATIONAL TESTS 2026
  // ==================================================

  {
    matchKey: "argentina-vs-south-africa",
    performances: [
      { category: "Coach", player: "Felipe Contepomi", value: "Argentina" },
      { category: "Coach", player: "Rassie Erasmus", value: "South Africa" },
      { category: "Captain", player: "Pablo Matera", value: "Argentina" },
      { category: "Captain", player: "Siya Kolisi", value: "South Africa" },
      { category: "Venue", player: "Estadio José Amalfitani", value: "Buenos Aires" },
      { category: "Referee", player: "Pierre Brousset", value: "FFR" },
      { category: "Assistant Referee 1", player: "Luc Ramos", value: "FFR" },
      { category: "Assistant Referee 2", player: "Craig Evans", value: "WRU" },
      { category: "TMO", player: "Ben Whitehouse", value: "WRU" },
      { category: "FPRO", player: "Ian Tempest", value: "RFU" },
    ],
  },

  {
    matchKey: "japan-vs-australia",
    performances: [
      { category: "Coach", player: "Eddie Jones", value: "Japan" },
      { category: "Coach", player: "Les Kiss", value: "Australia" },
      { category: "Captain", player: "Warner Dearns", value: "Japan" },
      { category: "Captain", player: "Harry Wilson", value: "Australia" },
      { category: "Venue", player: "Hanazono Rugby Stadium", value: "Osaka" },
      { category: "Referee", player: "Eoghan Cross", value: "IRFU" },
      { category: "Assistant Referee 1", player: "Paul Williams", value: "NZR" },
      { category: "Assistant Referee 2", player: "Morgan White", value: "HKCR" },
      { category: "TMO", player: "Richard Kelly", value: "NZR" },
    ],
  },

  {
    matchKey: "argentina-vs-australia-test-1",
    highlightsUrl: "https://www.youtube.com/watch?v=twiByM9GeKo",
    matchStats: {
      home: {
        metresMade: 420,
        carries: 88,
        defendersBeaten: 16,
        cleanBreaks: 4,
        offloads: 3,
        tacklesMade: 187,
        tacklesMissed: 14,
        turnoversWon: 5,
        penaltiesConceded: 14,
      },
      away: {
        metresMade: 358,
        carries: 139,
        defendersBeaten: 22,
        cleanBreaks: 3,
        offloads: 11,
        tacklesMade: 112,
        tacklesMissed: 18,
        turnoversWon: 10,
        penaltiesConceded: 9,
      },
    },
    performances: [
      { category: "Coach", player: "Felipe Contepomi", value: "Argentina" },
      { category: "Coach", player: "Joe Schmidt", value: "Australia" },
      { category: "Captain", player: "Pablo Matera", value: "Argentina" },
      { category: "Captain", player: "Allan Alaalatoa", value: "Australia" },
      { category: "Venue", player: "Estadio 23 de Agosto", value: "Jujuy" },
      { category: "Referee", player: "TBD", value: "TBD" },
      { category: "Assistant Referee 1", player: "TBD", value: "TBD" },
      { category: "Assistant Referee 2", player: "TBD", value: "TBD" },
      { category: "TMO", player: "TBD", value: "TBD" },
    ],
  },

{
  matchKey: "argentina-vs-australia-test-2",
highlightsUrl: "https://www.youtube.com/watch?v=PpCJ4WIGyPY",
matchStats: {
  home: { // Argentina
    metresMade: 385,
    carries: 153,
    defendersBeaten: 20,
    cleanBreaks: 3,
    offloads: 8,
    tacklesMade: 119,
    tacklesMissed: 17,
    turnoversWon: 6,
    penaltiesConceded: 12,
  },
  away: { // Australia
    metresMade: 295,
    carries: 94,
    defendersBeaten: 15,
    cleanBreaks: 4,
    offloads: 5,
    tacklesMade: 220,
    tacklesMissed: 32,
    turnoversWon: 5,
    penaltiesConceded: 10,
  },
},
  performances: [
    { category: "Coach", player: "Felipe Contepomi", value: "Argentina" },
    { category: "Coach", player: "Les Kiss", value: "Australia" },
    { category: "Captain", player: "Pablo Matera", value: "Argentina" },
    { category: "Captain", player: "Harry Wilson", value: "Australia" },
    { category: "Venue", player: "Estadio Malvinas Argentinas", value: "Mendoza" },
    { category: "Referee", player: "TBD", value: "TBD" },
    { category: "Assistant Referee 1", player: "TBD", value: "TBD" },
    { category: "Assistant Referee 2", player: "TBD", value: "TBD" },
    { category: "TMO", player: "TBD", value: "TBD" },
  ],
},

{
  matchKey: "polska-vs-czechy-2026",
  performances: [
    { category: "Competition", player: "Friendly", value: "International Test" },
    { category: "Venue", player: "Stadion Miejski im. Ojca Władysława Augustynka", value: "Nowy Sącz" },
    { category: "Selection note", player: "Polska", value: "44-player training squad announced" },
  ],
},

{
  matchKey: "australia-vs-south-africa-2026",
  highlightsUrl: "https://www.youtube.com/watch?v=v6br3W0tLsA",
  matchStats: {
    home: { // Australia
      metresMade: 0,
      carries: 0,
      defendersBeaten: 0,
      cleanBreaks: 0,
      offloads: 0,
      tacklesMade: 0,
      tacklesMissed: 0,
      turnoversWon: 0,
      penaltiesConceded: 0,
    },
    away: { // South Africa
      metresMade: 0,
      carries: 0,
      defendersBeaten: 0,
      cleanBreaks: 0,
      offloads: 0,
      tacklesMade: 0,
      tacklesMissed: 0,
      turnoversWon: 0,
      penaltiesConceded: 0,
    },
  },
},

{
  matchKey: "japan-vs-fiji-2026",
  timeline: [
    { minute: "0'", label: "Kick-off — Prince Chichibu Memorial Stadium, Tokyo" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=UBmCmbAQZKc",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Japan" },
    { category: "Coach", player: "TBD", value: "Fiji" },
    { category: "Venue", player: "Prince Chichibu Memorial Stadium", value: "Tokyo" },
  ],
},

// ==================================================
  // PACIFIC NATIONS CUP 2026
  // ==================================================

  {
  matchKey: "fiji-vs-canada",
  highlightsUrl: "https://www.youtube.com/watch?v=vp_oBxY1rlY",
matchStats: {
  home: { // Fiji
    metresMade: 480,
    carries: 135,
    defendersBeaten: 32,
    cleanBreaks: 10,
    offloads: 14,
    tacklesMade: 110,
    tacklesMissed: 28,
    turnoversWon: 9,
    penaltiesConceded: 11,
  },
  away: { // Canada
    metresMade: 310,
    carries: 95,
    defendersBeaten: 18,
    cleanBreaks: 5,
    offloads: 6,
    tacklesMade: 155,
    tacklesMissed: 35,
    turnoversWon: 6,
    penaltiesConceded: 10,
  },
},
  performances: [
    { category: "Coach", player: "Senirusi Seruvakula", value: "Fiji" },
    { category: "Coach", player: "Stephen Meehan", value: "Canada" },
    { category: "Captain", player: "Tevita Ikanivere", value: "Fiji" },
    { category: "Captain", player: "Lucas Rumball", value: "Canada" },
    { category: "Venue", player: "Hanazono Rugby Stadium", value: "Osaka" },
  ],
},

{
  matchKey: "japan-vs-usa",
  highlightsUrl: "https://www.world.rugby/pacific-nations-cup/en/",
matchStats: {
  home: { // Japan
    metresMade: 620,
    carries: 155,
    defendersBeaten: 38,
    cleanBreaks: 14,
    offloads: 12,
    tacklesMade: 95,
    tacklesMissed: 18,
    turnoversWon: 8,
    penaltiesConceded: 8,
  },
  away: { // USA
    metresMade: 240,
    carries: 85,
    defendersBeaten: 12,
    cleanBreaks: 3,
    offloads: 4,
    tacklesMade: 175,
    tacklesMissed: 42,
    turnoversWon: 4,
    penaltiesConceded: 12,
  },
},
  performances: [
    { category: "Coach", player: "Eddie Jones", value: "Japan" },
    { category: "Coach", player: "TBD", value: "USA" },
    { category: "Captain", player: "Naoto Saito", value: "Japan" },
    { category: "Captain", player: "TBD", value: "USA" },
    { category: "Venue", player: "Hanazono Rugby Stadium", value: "Osaka" },
  ],
},

{
  matchKey: "japan-vs-fiji",
  highlightsUrl: "https://www.youtube.com/watch?v=r_Vwr3Gw3lY",
  performances: [
    { category: "Coach", player: "Eddie Jones", value: "Japan" },
    { category: "Coach", player: "Senirusi Seruvakula", value: "Fiji" },
    { category: "Captain", player: "Naoto Saito", value: "Japan" },
    { category: "Captain", player: "Tevita Ikanivere", value: "Fiji" },
    { category: "Venue", player: "Prince Chichibu Memorial Stadium", value: "Tokyo" },
  ],
},

{
  matchKey: "canada-vs-usa",
  highlightsUrl: "https://www.youtube.com/watch?v=V07GdmaihRo",
  performances: [
    { category: "Coach", player: "Stephen Meehan", value: "Canada" },
    { category: "Coach", player: "Scott Lawrence", value: "USA" },
    { category: "Captain", player: "Lucas Rumball", value: "Canada" },
    { category: "Captain", player: "Jason Damm", value: "USA" },
    { category: "Venue", player: "Prince Chichibu Memorial Stadium", value: "Tokyo" },
  ],
},

// ==================================================
  // BLEDISLOE CUP 2026
// ==================================================

{
  matchKey: "new-zealand-vs-australia-test-1",
   timeline: [
    { minute: "0'", label: "Kick-off — Eden Park, Auckland" },
    { minute: "8'", label: "TRY: Australia - Tom Wright" },
    { minute: "10'", label: "CON: Australia - Ryan Lonergan" },
    { minute: "12'", label: "TRY: New Zealand - Peter Lakai" },
    { minute: "14'", label: "CON: New Zealand - Damian McKenzie" },
    { minute: "16'", label: "TRY: New Zealand - Tupou Vaa'i" },
    { minute: "18'", label: "CON: New Zealand - Damian McKenzie" },
    { minute: "33'", label: "PEN: New Zealand - Damian McKenzie" },
    { minute: "37'", label: "TRY: Australia - Harry Wilson" },
    { minute: "39'", label: "CON: Australia - Ryan Lonergan" },
    { minute: "40'", label: "Half Time — New Zealand 17-14 Australia" },
    { minute: "49'", label: "TRY: New Zealand - Cam Roigard" },
    { minute: "51'", label: "CON: New Zealand - Damian McKenzie" },
    { minute: "55'", label: "TRY: New Zealand - Codie Taylor" },
    { minute: "57'", label: "CON: New Zealand - Damian McKenzie" },
    { minute: "66'", label: "TRY: New Zealand - Leroy Carter" },
    { minute: "68'", label: "CON: New Zealand - Damian McKenzie" },
    { minute: "73'", label: "TRY: New Zealand - Josh Moorby" },
    { minute: "75'", label: "CON: New Zealand - Damian McKenzie" },
    { minute: "76'", label: "TRY: Australia - Josh Nasser" },
    { minute: "78'", label: "CON: Australia - Ryan Lonergan" },
    { minute: "80'", label: "TRY: New Zealand - Will Jordan" },
    { minute: "80'", label: "Full Time — New Zealand 50-19 Australia" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=9AmQQqPEFlY",
  matchStats: {
    home: { // New Zealand
      metresMade: 0,
      carries: 0,
      defendersBeaten: 0,
      cleanBreaks: 0,
      offloads: 0,
      tacklesMade: 0,
      tacklesMissed: 0,
      turnoversWon: 0,
      penaltiesConceded: 0,
    },
    away: { // Australia
      metresMade: 0,
      carries: 0,
      defendersBeaten: 0,
      cleanBreaks: 0,
      offloads: 0,
      tacklesMade: 0,
      tacklesMissed: 0,
      turnoversWon: 0,
      penaltiesConceded: 0,
    },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Ethan de Groot" },
      { number: 2, name: "Codie Taylor (C)" },
      { number: 3, name: "Fletcher Newell" },
      { number: 4, name: "Scott Barrett" },
      { number: 5, name: "Josh Lord" },
      { number: 6, name: "Tupou Vaa'i" },
      { number: 7, name: "Peter Lakai" },
      { number: 8, name: "Wallace Sititi" },
      { number: 9, name: "Cam Roigard" },
      { number: 10, name: "Damian McKenzie" },
      { number: 11, name: "Leroy Carter" },
      { number: 12, name: "Jordie Barrett" },
      { number: 13, name: "Quinn Tupaea" },
      { number: 14, name: "Will Jordan" },
      { number: 15, name: "Beauden Barrett" },
    ],
    homeBench: [
      { number: 16, name: "Asafo Aumua" },
      { number: 17, name: "George Bower" },
      { number: 18, name: "Pasilio Tosi" },
      { number: 19, name: "Shannon Frizell" },
      { number: 20, name: "Anton Segner" },
      { number: 21, name: "Kyle Preston" },
      { number: 22, name: "Rieko Ioane" },
      { number: 23, name: "Josh Moorby" },
    ],
    awayStarting: [
      { number: 1, name: "Angus Bell" },
      { number: 2, name: "Brandon Paenga-Amosa" },
      { number: 3, name: "Allan Alaalatoa" },
      { number: 4, name: "Jeremy Williams" },
      { number: 5, name: "Lukhan Salakaia-Loto" },
      { number: 6, name: "Rob Valetini" },
      { number: 7, name: "Fraser McReight" },
      { number: 8, name: "Harry Wilson (C)" },
      { number: 9, name: "Ryan Lonergan" },
      { number: 10, name: "Ben Donaldson" },
      { number: 11, name: "Joseph-Aukuso Suaalii" },
      { number: 12, name: "Len Ikitau" },
      { number: 13, name: "Isaac Henry" },
      { number: 14, name: "Max Jorgensen" },
      { number: 15, name: "Tom Wright" },
    ],
    awayBench: [
      { number: 16, name: "Josh Nasser" },
      { number: 17, name: "Aidan Ross" },
      { number: 18, name: "Massimo De Lutiis" },
      { number: 19, name: "Lachlan Shaw" },
      { number: 20, name: "Nick Champion de Crespigny" },
      { number: 21, name: "Tate McDermott" },
      { number: 22, name: "Declan Meredith" },
      { number: 23, name: "Harry Potter" },
    ],
  },
  performances: [
    { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
    { category: "Coach", player: "Les Kiss", value: "Australia" },
    { category: "Captain", player: "Codie Taylor", value: "New Zealand" },
    { category: "Captain", player: "Harry Wilson", value: "Australia" },
    { category: "Venue", player: "Eden Park", value: "Auckland" },
    { category: "Competition", player: "Bledisloe Cup", value: "1st Test 2026" },
    { category: "Referee", player: "Andrew Brace", value: "IRFU" },
    { category: "Assistant Referee 1", player: "Luke Pearce", value: "RFU" },
    { category: "Assistant Referee 2", player: "Damian Schneider", value: "UAR" },
    { category: "TMO", player: "Mike Adamson", value: "SRU" },
    { category: "FPRO", player: "Marius van der Westhuizen", value: "SARU" },
    { category: "Kick-off", player: "19:10 NZDT", value: "Saturday 10 October 2026" },
    { category: "Try Scorers", player: "Peter Lakai, Tupou Vaa'i, Cam Roigard, Codie Taylor, Leroy Carter, Josh Moorby, Will Jordan", value: "New Zealand" },
    { category: "Try Scorers", player: "Tom Wright, Harry Wilson, Josh Nasser", value: "Australia" },
    { category: "Note", player: "New Zealand", value: "Retained Bledisloe Cup for 24th consecutive year" },
    { category: "Note", player: "Eden Park", value: "Extended unbeaten record to 54 Tests" },
  ],
},

{
  matchKey: "australia-vs-new-zealand-test-2",
  timeline: [
    { minute: "0'", label: "Kick-off — Accor Stadium, Sydney" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=5xZtI5pUl-o",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  lineups: {
    homeStarting: [
      { number: 1, name: "Aidan Ross" },
      { number: 2, name: "Josh Nasser" },
      { number: 3, name: "Allan Alaalatoa" },
      { number: 4, name: "Jeremy Williams" },
      { number: 5, name: "Lukhan Salakaia-Loto" },
      { number: 6, name: "Rob Valetini" },
      { number: 7, name: "Fraser McReight" },
      { number: 8, name: "Harry Wilson (C)" },
      { number: 9, name: "Ryan Lonergan" },
      { number: 10, name: "Declan Meredith" },
      { number: 11, name: "Harry Potter" },
      { number: 12, name: "Isaac Henry" },
      { number: 13, name: "Joseph-Aukuso Suaalii" },
      { number: 14, name: "Max Jorgensen" },
      { number: 15, name: "Tom Wright" },
    ],
    homeBench: [
      { number: 16, name: "Billy Pollard" },
      { number: 17, name: "Angus Bell" },
      { number: 18, name: "Massimo De Lutiis" },
      { number: 19, name: "Josh Canham" },
      { number: 20, name: "Carlo Tizzano" },
      { number: 21, name: "Kalani Thomas" },
      { number: 22, name: "Harry McLaughlin-Phillips" },
      { number: 23, name: "Filipo Daugunu" },
    ],
    awayStarting: [
      { number: 1, name: "George Bower" },
      { number: 2, name: "Codie Taylor (C)" },
      { number: 3, name: "Fletcher Newell" },
      { number: 4, name: "Scott Barrett" },
      { number: 5, name: "Fabian Holland" },
      { number: 6, name: "Tupou Vaa'i" },
      { number: 7, name: "Peter Lakai" },
      { number: 8, name: "Wallace Sititi" },
      { number: 9, name: "Cam Roigard" },
      { number: 10, name: "Damian McKenzie" },
      { number: 11, name: "Josh Moorby" },
      { number: 12, name: "Jordie Barrett" },
      { number: 13, name: "Quinn Tupaea" },
      { number: 14, name: "Will Jordan" },
      { number: 15, name: "Beauden Barrett" },
    ],
    awayBench: [
      { number: 16, name: "Samisoni Taukei'aho" },
      { number: 17, name: "Xavier Numia" },
      { number: 18, name: "Pasilio Tosi" },
      { number: 19, name: "Shannon Frizell" },
      { number: 20, name: "Du'Plessis Kirifi" },
      { number: 21, name: "Cortez Ratima" },
      { number: 22, name: "Timoci Tavatavanawai" },
      { number: 23, name: "Rieko Ioane" },
    ],
  },
  performances: [
    { category: "Coach", player: "Les Kiss", value: "Australia" },
    { category: "Coach", player: "Dave Rennie", value: "New Zealand" },
    { category: "Captain", player: "Harry Wilson", value: "Australia" },
    { category: "Captain", player: "Codie Taylor", value: "New Zealand" },
    { category: "Venue", player: "Accor Stadium", value: "Sydney" },
    { category: "Note", player: "New Zealand", value: "Already retained the Bledisloe Cup" },
    { category: "Note", player: "Lukhan Salakaia-Loto", value: "50th Test cap" },
  ],
},
];